import React from "react";

const ButtonLoader = () => (
  <div className="loader-container">
    <div className="loader"></div>
  </div>
);

export default ButtonLoader;
